(() => {
jQuery(document).ready(function($) {
    const $form = $("#filter-form");
    const $toggle = $("#filter-toggle");
    const $searchField = $('#product_name_search');
    const $productCat = $("#product_cat");
    const $filterCor = $("#filter_cor");
    const $orderby = $("#orderby");
    $("#product_cat, #filter_cor").each(function() {
        const placeholder = $(this).data("holder") || "";
        $(this).select2({
            placeholder: 'Selecione...',
            allowClear: true,
            width: "100%",
            closeOnSelect: false,
            language: {
                noResults: function() {
                    return "Nenhum resultado encontrado";
                }
            }
        });
    });
    if ($orderby.length) $orderby.select2({
        width: "100%",
        placeholder: "Ordenar por",
        minimumResultsForSearch: Infinity
    });
    function handleSearchField(e) {
        const searchValue = $.trim($searchField.val());
        if (searchValue) {
            e.preventDefault();
            const baseUrl = window.location.origin; // sempre envia para home
            const url = new URL(baseUrl);
            url.searchParams.set("s", searchValue);
            url.searchParams.set("post_type", "product");
            window.location.href = url.toString();
            return true;
        }
        return false;
    }
    // === Envio do formulário ===
    $form.on("submit", function(e) {
        // 1️⃣ Se for busca, ignora os demais campos
        if (handleSearchField(e)) return;
        e.preventDefault();
        const params = new URLSearchParams();
        const catValue = $productCat.val();
        const corValue = $filterCor.val();
        const orderbyValue = $orderby.val();
        if (catValue && catValue.length > 0) params.set("product_cat", catValue.join(","));
        if (orderbyValue) params.set("orderby", orderbyValue);
        if (corValue && corValue.length > 0) params.set("filter_cor", corValue.join(","));
        if (catValue && catValue.length > 0 && corValue && corValue.length > 0) params.set("query_type_cor", "or");
        const url = new URL(window.location.href);
        url.search = params.toString();
        window.location.href = url.toString();
    });
    // === Alternar exibição do formulário ===
    if ($toggle.length && $form.length) $toggle.on("click", function() {
        $form.css("display", $form.css("display") === "flex" ? "none" : "flex");
    });
    // === Pré-selecionar valores vindos da URL ===
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach((value, key)=>{
        const $el = $(`[name="${key}"]`);
        if ($el.length) {
            const values = value.split(",");
            $el.val(values).trigger("change"); // atualiza Select2
        }
    });
});


(function($) {
    'use strict';
    $(document).ready(function() {
        $(document).on('submit', 'form[action*="yith/waitlist-register"]', function(e) {
            e.preventDefault();
            var $form = $(this);
            var $submitBtn = $form.find('.yith-wcwtl-submit1, input[type="submit"]');
            var $emailField = $form.find('#yith-wcwtl-email');
            var $policyCheck = $form.find('#yith-wcwtl-policy-check');
            var email = $emailField.val().trim();
            $('.yith-wcwtl-ajax-message').remove();
            $emailField.removeClass('yith-wcwtl-error-field');
            $policyCheck.removeClass('yith-wcwtl-error-field');
            var hasError = false;
            if (!email || !isValidEmail(email)) {
                showMessage($form, "Por favor, informe um e-mail v\xe1lido.", 'error');
                $emailField.addClass('yith-wcwtl-error-field').focus();
                hasError = true;
            }
            if (!$policyCheck.is(':checked')) {
                if (!hasError) showMessage($form, "Voc\xea precisa aceitar a pol\xedtica de privacidade para continuar.", 'error');
                $policyCheck.closest('label').css({
                    outline: '2px solid #f44336',
                    outlineOffset: '2px',
                    borderRadius: '2px'
                });
                hasError = true;
            }
            if (hasError) return;
            $submitBtn.prop('disabled', true).addClass('yith-wcwtl-loading');
            $form.addClass('yith-wcwtl-form--submitting');
            $.ajax({
                url: $form.attr('action'),
                method: 'POST',
                data: {
                    'yith-wcwtl-email': email
                },
                dataType: 'json',
                success: function(response) {
                    if (response === true || response && response.success === true) {
                        showMessage($form, "Cadastro realizado com sucesso! Voc\xea ser\xe1 notificado assim que o produto estiver dispon\xedvel.", 'success');
                        $form[0].reset();
                    } else {
                        var errorMsg = response && response.message ? response.message : "N\xe3o foi poss\xedvel realizar o cadastro. Verifique seu e-mail e tente novamente.";
                        showMessage($form, errorMsg, 'error');
                    }
                },
                error: function(jqXHR) {
                    var fallbackMsg = "Erro de conex\xe3o. Tente novamente mais tarde.";
                    if (jqXHR.responseJSON && jqXHR.responseJSON.message) fallbackMsg = jqXHR.responseJSON.message;
                    showMessage($form, fallbackMsg, 'error');
                },
                complete: function() {
                    $submitBtn.prop('disabled', false).removeClass('yith-wcwtl-loading');
                    $form.removeClass('yith-wcwtl-form--submitting');
                }
            });
        });
        $(document).on('change', '#yith-wcwtl-policy-check', function() {
            if ($(this).is(':checked')) $(this).closest('label').css({
                outline: '',
                outlineOffset: '',
                borderRadius: ''
            });
        });
        function isValidEmail(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        }
        function showMessage($form, message, type) {
            var $msg = $('<div>').addClass('yith-wcwtl-ajax-message yith-wcwtl-message--' + type).html('<span class="yith-wcwtl-message__icon"></span><span class="yith-wcwtl-message__text">' + message + '</span>');
            $form.after($msg);
            setTimeout(function() {
                $msg.fadeOut(400, function() {
                    $(this).remove();
                });
            }, 8000);
        }
    });
})(jQuery);



})();
//# sourceMappingURL=index.js.map
